export const tab3ExtendedInitialData = {
  isSurgeryMoreThan3Months: '',
  isRecommendationForMedicines: '',
  isAdditionalExistingMedicalCondition: '',
  surgeryMoreThan3MonthsIdentifica: [],
  recommendationForMedicinesIdentifica: [],
  additionalExistingMedicalConditionIdentifica: [],
};
